module.exports = __webpack_public_path__ + "img/1_023.948c7cb4.jpg";